import React, { useEffect, useState } from 'react';
import { Button, Card, Checkbox, FormControlLabel, FormGroup, List, ListItem } from '@mui/material';

function WordTranslationComponent({ word, wordSetter }) {
    const [checkedValues, setCheckedValues] = useState([]);

    const handleCheckboxChange = (value) => {
        setCheckedValues((prevValues) => {
            if (prevValues.includes(value)) {
                return prevValues.filter((item) => item !== value);
            } else {
                return [...prevValues, value];
            }
        });
    };

    useEffect(() => {
        if (word.translation.length === 1) {
            let initialValues = [];
            word.translation.forEach(item => {
                initialValues.push(item.one);
            });
            setCheckedValues(initialValues);
        } else {
            setCheckedValues([]);
        }
    }, [word])

    useEffect(() => {
        wordSetter(checkedValues);
    }, [checkedValues]);

    return (
        <div>
            <List>
                {word.translation.map((item, index) => (
                    <ListItem key={index}>
                        <Card style={{ width: '100%', padding: '10px' }}>
                        {item.spacyPos}
                        <FormGroup row>
                            <FormControlLabel
                                control={<Checkbox checked={checkedValues.includes(item.one)} onChange={() => handleCheckboxChange(item.one)} />}
                                label={item.one}
                            />
                            {item.all.map((translation, idx) => (
                                <FormControlLabel
                                    key={idx}
                                    control={
                                        <Checkbox checked={checkedValues.includes(translation)} onChange={() => handleCheckboxChange(translation)} />
                                    }
                                    label={translation}
                                />
                            ))}
                        </FormGroup>
                        </Card>
                    </ListItem>
                ))}
            </List>
            {/* <Button variant="outlined" onClick={handleButtonClick}>
                OK
            </Button> */}
        </div>
    );
}

export default WordTranslationComponent;
